(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["page-how-it-works"]) return;
  try {
    
	$(document).ready(function(){
      $('.accordion-list-item [data-toggle*="toggle-"]').on("click", event => {
          event.preventDefault();
          const src = event.target;
          if (
            $(src)
              .parent()
              .hasClass("active")
          ) {
            $(src)
              .parent()
              .removeClass("active");
          } else {
            $(src)
              .parent()
              .parent()
              .children()
              .removeClass("active");
            $(src)
              .parent()
              .addClass("active");
          }
        });
	});

  } catch(e) { console.error(e); }
})();
})();
